import { LoadableFactory, SaveableFactory } from '®shared/data';

import {
  UserSubscribedListsActionTypes,
  UserSubscribedListsActions,
} from './user-subscribed-lists.actions';
import { UserSubsubscribedListsState } from './user-subscribed-lists.state';

export function userSubscribedListsReducer(
  state: UserSubsubscribedListsState,
  action: UserSubscribedListsActions,
): UserSubsubscribedListsState {
  switch (action.type) {
    case UserSubscribedListsActionTypes.FETCH_LIST_SUBSCRIPTION: {
      const { listId } = action.payload;
      return {
        ...state,
        [listId]: LoadableFactory.loading(),
      };
    }
    case UserSubscribedListsActionTypes.FETCH_LIST_SUBSCRIPTION_SUCCESS: {
      const { listId, isSubscribed } = action.payload;
      return {
        ...state,
        [listId]: LoadableFactory.loaded(isSubscribed),
      };
    }
    case UserSubscribedListsActionTypes.FETCH_LIST_SUBSCRIPTION_FAILED: {
      const { error, listId } = action.payload;
      return {
        ...state,
        [listId]: LoadableFactory.errored<boolean>(error),
      };
    }
    case UserSubscribedListsActionTypes.UPDATE_LIST_SUBSCRIPTION: {
      const { listId } = action.payload;
      return {
        ...state,
        [listId]: {
          data: true,
          ...SaveableFactory.saving(),
        },
      };
    }
    case UserSubscribedListsActionTypes.UPDATE_LIST_SUBSCRIPTION_SUCCESS: {
      const { listId } = action.payload;
      return {
        ...state,
        [listId]: { data: true, ...SaveableFactory.reset() },
      };
    }
    case UserSubscribedListsActionTypes.UPDATE_LIST_SUBSCRIPTION_FAILED: {
      const { error, listId } = action.payload;
      return {
        ...state,
        [listId]: SaveableFactory.errorSaving(error),
      };
    }
    default: {
      return state;
    }
  }
}
